function canHideRelatedItemsTab () {

	return document.querySelector('.pdRelItmsProdShadeOptions, .pdRelItmsProd') === null;

}

export default canHideRelatedItemsTab;
